export default __webpack_public_path__ + "static/ctaModule_table_mobile-8b424ba904741e9b6dceff3d355030fa.png";